import {  Component, OnInit} from '@angular/core';



@Component({
  selector: 'app-bi-report',
  templateUrl: './bi-report.component.html',
  styleUrls: ['./bi-report.component.css']
})

export class BiReportComponent implements OnInit {
    url = `<iframe class="bi_frame" height='100%' width='100%'
    src="https://app.powerbi.com/view?r=eyJrIjoiZWU0NjRlOGItMzUzMy00YWU0LWI0ZmYtNTM3MTdiODMwYTI2IiwidCI6ImJhMGI5MmNhLTg4ZjUtNDBmZS04NjVjLWI2MTQyODkwZTg0MiJ9" 
     allowfullscreen></iframe>`;
    
    constructor() {}


  ngOnInit() {
  }

}
